import { useQuery } from "@tanstack/react-query"

import api from "../../services"

import { IJobPostDetails } from "../../interfaces/job_posts"

import cookiesHelper from "../../helpers/cookies";

const useGetJobPostDetails = (id: number) => {
    const queryFn = async (): Promise<IJobPostDetails> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const response = await api.get(`/job-posts/details/${id}`)
        return response.data
    }

    return useQuery({
        queryKey: ['job-post', id],
        queryFn,
        enabled: !!id
    });
}

export default useGetJobPostDetails;